import { createContext } from 'react';
import type { TeamEventOfType, TeamEventType } from '@/model/TeamEvent.model';

export type TeamEventContextType = {
  subscribe: <T extends TeamEventType>(
    type: T,
    listener: (event: TeamEventOfType<T>) => void,
    options: { signal: AbortSignal }
  ) => void;
};

export const TeamEventContext = createContext<TeamEventContextType | null>(null);
